import React from 'react';
import { cn } from 'v5/platform/dom/cn';
import { getEventHoursLabel } from 'v1/helpers/byModel/EventHelper';
import { useTranslation } from 'react-i18next';
import type { Event } from '__types__/v1/models/Event';

export type FullCalendarEventData = Partial<Event> & {
  title: string;
  borderColor?: string;
};

interface FullCalendarEventProps
  extends Omit<React.ComponentPropsWithoutRef<'div'>, 'children'> {
  event: FullCalendarEventData;
}

const FullCalendarEvent = React.forwardRef<
  HTMLDivElement,
  FullCalendarEventProps
>(({ event, className, style, ...rest }, ref) => {
  const { title, borderColor } = event;
  const { t } = useTranslation();
  return (
    <div className={'tailwind-root contents'}>
      <div
        ref={ref}
        {...rest}
        style={{
          borderColor: borderColor || 'var(--color-border-default)'
        }}
        className={cn(
          'flex flex-col gap-0.5 px-2 py-1.5 bg-white!',
          'border border-t-[4px] rounded cursor-pointer',
          'transition-all duration-150 ease-in-out h-full overflow-hidden',
          'shadow-sm hover:shadow-md',
          'focus:outline-none focus-visible:shadow-md focus-visible:bg-bg-subtle!',
          className
        )}
        role="button"
        tabIndex={0}
      >
        <span
          className={cn(
            'font-semibold text-sm leading-snug truncate text-fg-default'
          )}
        >
          {title}
        </span>
        <span
          className={cn(
            'text-sm font-normal leading-snug truncate text-fg-muted'
          )}
        >
          {getEventHoursLabel(event, t, { use24HourFormat: true })}
        </span>
      </div>
    </div>
  );
});

export default FullCalendarEvent;
